// TODO: This page is not part of the official requirements or Figma designs — added for debugging/testing purposes only.
import { TFunction } from 'i18next'
import { z } from 'zod'

export const residentProfileSettingsSchema = z.object({
  apartment: z.boolean(),
  birth: z.boolean(),
  email: z.boolean(),
  firstName: z.boolean(),
  floor: z.boolean(),
  lastName: z.boolean(),
  leaseEnd: z.boolean(),
  leaseStart: z.boolean(),
  moveInDate: z.boolean(),
  moveOutDate: z.boolean(),
  pets: z.boolean(),
  phone: z.boolean(),
  street: z.boolean(),
  zipCode: z.boolean(),
})

export type ResidentProfileSettingsFormValues = z.infer<typeof residentProfileSettingsSchema>

type FieldConfig = {
  label: string
  name: keyof ResidentProfileSettingsFormValues
}

type SectionConfig = {
  title: string
  fields: FieldConfig[]
}

export const getResidentProfileFieldSections = (
  t: TFunction<['building-dashboard']>,
): SectionConfig[] => [
  {
    fields: [
      {
        label: t('building-dashboard:residentProfileSettings.fields.firstName.label'),
        name: 'firstName',
      },
      {
        label: t('building-dashboard:residentProfileSettings.fields.lastName.label'),
        name: 'lastName',
      },
      { label: t('building-dashboard:residentProfileSettings.fields.email.label'), name: 'email' },
      { label: t('building-dashboard:residentProfileSettings.fields.phone.label'), name: 'phone' },
      { label: t('building-dashboard:residentProfileSettings.fields.birth.label'), name: 'birth' },
    ],
    title: t('building-dashboard:residentProfileSettings.sections.personal.title'),
  },
  {
    fields: [
      {
        label: t('building-dashboard:residentProfileSettings.fields.street.label'),
        name: 'street',
      },
      {
        label: t('building-dashboard:residentProfileSettings.fields.zipCode.label'),
        name: 'zipCode',
      },
      { label: t('building-dashboard:residentProfileSettings.fields.floor.label'), name: 'floor' },
      {
        label: t('building-dashboard:residentProfileSettings.fields.apartment.label'),
        name: 'apartment',
      },
    ],
    title: t('building-dashboard:residentProfileSettings.sections.address.title'),
  },
  {
    fields: [
      {
        label: t('building-dashboard:residentProfileSettings.fields.moveInDate.label'),
        name: 'moveInDate',
      },
      {
        label: t('building-dashboard:residentProfileSettings.fields.moveOutDate.label'),
        name: 'moveOutDate',
      },
      {
        label: t('building-dashboard:residentProfileSettings.fields.leaseStart.label'),
        name: 'leaseStart',
      },
      {
        label: t('building-dashboard:residentProfileSettings.fields.leaseEnd.label'),
        name: 'leaseEnd',
      },
      { label: t('building-dashboard:residentProfileSettings.fields.pets.label'), name: 'pets' },
    ],
    title: t('building-dashboard:residentProfileSettings.sections.leaseAndLiving.title'),
  },
]

export const composeFormValues = (hiddenFields: string[]): ResidentProfileSettingsFormValues => ({
  apartment: !hiddenFields.includes('apartment'),
  birth: !hiddenFields.includes('birth'),
  email: !hiddenFields.includes('email'),
  firstName: !hiddenFields.includes('firstName'),
  floor: !hiddenFields.includes('floor'),
  lastName: !hiddenFields.includes('lastName'),
  leaseEnd: !hiddenFields.includes('leaseEnd'),
  leaseStart: !hiddenFields.includes('leaseStart'),
  moveInDate: !hiddenFields.includes('moveInDate'),
  moveOutDate: !hiddenFields.includes('moveOutDate'),
  pets: !hiddenFields.includes('pets'),
  phone: !hiddenFields.includes('phone'),
  street: !hiddenFields.includes('street'),
  zipCode: !hiddenFields.includes('zipCode'),
})

export const composeHiddenFields = (values: ResidentProfileSettingsFormValues): string[] =>
  (Object.entries(values) as [string, boolean][])
    .filter(([, visible]) => !visible)
    .map(([field]) => field)
